import { HttpClient, RestApplicationClient } from '../generated-types';

class WebRestApplicationClient<T> extends RestApplicationClient<T> {
    constructor(protected httpClient: HttpClient<T>) {
        super(httpClient);
        this.httpClient = httpClient;
    }
}

export default WebRestApplicationClient;
